export default "__VITE_ASSET__EnpPGtVn__"